import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggleMenu() {
    this._toggleHeaderDisplay('menu');
  }

  toggleCart() {
    this._toggleHeaderDisplay('cart');
  }

  _toggleHeaderDisplay(value) {
    const menu = document.getElementById('the-header');

    if (!menu) {
      return;
    }

    if (menu.getAttribute('display') === value) {
      menu.removeAttribute('display');
    } else {
      menu.setAttribute('display', value);
    }
  }
}
